// Carto ended keyless basemap access (~Aug 2026): keyless responses are
// HTTP 200 PNGs with an "API KEY REQUIRED" watermark baked in. Same key as
// QuestApp's VITE_CARTO_KEY; it is public — it appears in tile URLs anyway.
export const CARTO_KEY = 'cb1_28x3_1_7ed6b00a9b6641718434b992';
